export const GAME_TIME_LEFT = 'game-time-left';
export const GAME_START_TIME = 'game-start-time';
export const GAME_END_TIME = 'game-end-time';
export const REMAINING_MINUTES_FOR_NOTIFY = 10;
export const USER_PASSWORD_MIN_LENGTH = 8;
export const AWARD_BADGE_NAX_SIZE_MB = 2;
export const MAX_TASK_IMAGE_SIZE_MB = 8;
export const INITIAL_ADMIN_TASK_LOCATION_COORDINATES = { lat: 51.1657, lng: 10.4515 };
export const MIN_ADMIN_TASK_LOCATION_RADIUS = 20;
export const MAX_ADMIN_TASK_LOCATION_RADIUS = 100;
export const RALLY_SESSIONS_LIST_PER_PAGE_ITEMS = 10;
export const LOCATION_TASK_DEFAULT_RADIUS = 20;
export const MAX_FILE_UPLOAD_SIZE_MB = 64;
export const MAX_IMAGE_UPLOAD_SIZE_MB = 16;
export const USER_UPLOAD_IMAGE_COMPRESSION_SIZE_MB = 2;
export const AWARD_BADGE_COMPRESSION_SIZE_MB = 2;
export const ADMIN_TASK_IMAGE_COMPRESSION_SIZE_MB = 8;
export const INSTITUTIONS_LIST_PER_PAGE_ITEMS = 20;
export const EDITORS_LIST_PER_PAGE_ITEMS = 20;
export const MAX_PDF_UPLOAD_SIZE_MB = 20;
